// Scrawl Adult
import ScrawlLogo from "images/games/scrawl-adult.png";
import ScrawlStoreBackground from "images/storeBackgrounds/scrawl-green.png";
import ScrawlStoreLogo from "images/storeLogos/scrawl-adult.png";
import ScrawlCardLogo from "images/gameCards/logo/scrawl-adult.png";
import ScrawlCardBackground from "images/gameCards/background/scrawl-green.jpg";
import ScrawlMobilePreview1 from "images/gameStorePreviews/scrawl/scrawl-mobile-1.png";
import ScrawlMobilePreview2 from "images/gameStorePreviews/scrawl/scrawl-mobile-2.png";
import ScrawlDesktopPreview1 from "images/gameStorePreviews/scrawl/scrawl-tv-ls.png";
import ScrawlDesktopPreview2 from "images/gameStorePreviews/scrawl/scrawl-desktop-2.png";
import ScrawlTinyCard from "images/tinyCards/scrawl-adult.png";

// Colour Brain Junior
import ColourBrainLogo from "images/games/colour-brain-junior.png";
import ColourBrainStoreBackground from "images/storeBackgrounds/colour-brain-junior.png";
import ColourBrainStoreLogo from "images/storeLogos/colourBrainJuniorLogo.png";
import ColourBrainCardLogo from "images/gameCards/logo/colourBrainJuniorLogo.png";
import ColourBrainCardBackground from "images/gameCards/background/colour-brain-junior.jpg";
import ColourBrainMobilePreview1 from "images/gameStorePreviews/colourBrain/colourbrain-mobile-1.png";
import ColourBrainMobilePreview2 from "images/gameStorePreviews/colourBrain/colourbrain-mobile-2.png";
import ColourBrainDesktopPreview1 from "images/gameStorePreviews/colourBrain/colourbrain-desktop-1.png";
import ColourBrainDesktopPreview2 from "images/gameStorePreviews/colourBrain/colourbrain-desktop-2.png";
import ColourBrainTinyCard from "images/tinyCards/colour-brain-junior.png";

// Moosic And Moovies
import MoosicLogo from "images/games/moosicAndMoovies.png";
import MoosicStoreBackground from "images/storeBackgrounds/MoosicAndMooviesStoreBack.png";
import MoosicStoreLogo from "images/games/moosicAndMoovies.png";
import MoosicCardLogo from "images/gameCards/logo/MoosicAndMoovies.png";
import MoosicCardBackground from "images/gameCards/background/moosicAndMoovies.jpg";
import MoosicMobilePreview1 from "images/gameStorePreviews/herd/herd-mobile-1.png";
import MoosicMobilePreview2 from "images/gameStorePreviews/herd/herd-mobile-2.png";
import MoosicDesktopPreview1 from "images/gameStorePreviews/herd/herd-desktop-1.png";
import MoosicDesktopPreview2 from "images/gameStorePreviews/herd/herd-desktop-2.png";
import MoosicTinyCard from "images/tinyCards/moosicAndMoovies.png";

// Catchphrase Addon 1
import CatchphraseLogo from "images/games/catchphrase-addon-1-logo.png";
import CatchphraseStoreBackground from "images/storeBackgrounds/catchphrase-addon-1-bg.jpg";
import CatchphraseStoreLogo from "images/games/catchphrase-addon-1-logo.png";
import CatchphraseCardLogo from "images/gameCards/logo/catchphrase-addon-1-cardlogo.png";
import CatchphraseCardBackground from "images/gameCards/background/catchphrase-addon-1-cardbg.jpg";
import CatchphraseMobilePreview1 from "images/gameStorePreviews/catchphrase/catchphrase-mobile-1.png";
import CatchphraseMobilePreview2 from "images/gameStorePreviews/catchphrase/catchphrase-mobile-2.png";
import CatchphraseDesktopPreview1 from "images/gameStorePreviews/catchphrase/catchphrase-desktop-1.jpg";
import CatchphraseDesktopPreview2 from "images/gameStorePreviews/catchphrase/catchphrase-desktop-2.jpg";
import CatchphraseTinyCard from "images/tinyCards/catchphrase-addon-1-tinycard.png";


import { APP_TYPES } from "./AppTypes";

const GameAddonList = [
    //{
    //    type: "Addon",
    //    name: "Moosic & Moovies",
    //    pack: 1,
    //    addonId: "moosic_moovies",
    //    forGameId: "herd_mentality",
    //    enabled: true,
    //    logo: MoosicLogo,
    //    description: "Herd Mentality is back, and it's all about Moosic and Moovies!",
    //    productId: process.env.REACT_APP_MOOSIC_MOOVIES_PID,
    //    supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
    //    price: 2.99,
    //    storeSlug: '/shop/addons/moosic-moovies',
    //    gameInfo: {
    //        minAge: 12,
    //        minPlayers: 3,
    //        avgRoundLength: 600,
    //        avgRoundLengthText: '20 Mins',
    //        descriptions: [
    //            {
    //                header: "LIGHTS, CAMERA, CATTLE!",
    //                body: "Herd Mentality is back in the field, and this time the questions are all about MOOsic and MOOvies!"
    //            }
    //        ],
    //        //banner: "Requires Scrawl",
    //    },
    //    upsellIds: ["scrawl", "catchphrase", "cant_say_umm"],
    //    meta: {
    //        cardLogo: MoosicCardLogo,
    //        cardBackground: MoosicCardBackground,
    //        cardPriceColour: '#10232B',
    //        storeBackground: MoosicStoreBackground,
    //        storeBackgroundColour: '#FFFFFF',
    //        storeInfoBackground: '#FFFFFF',
    //        storeLogo: MoosicStoreLogo,
    //        storeAccentColour: '#000000',
    //        gameMenuTextColour: '#000000',
    //        gameMenuBackgroundColour: '#FFFFFF',
    //        previewImages: {
    //            mobile1: MoosicMobilePreview1,
    //            mobile2: MoosicMobilePreview2,
    //            desktop1: MoosicDesktopPreview1,
    //            desktop2: MoosicDesktopPreview2,
    //        },
    //        tinyCard: MoosicTinyCard,
    //    },
    //    pricing: {
    //        gb: {
    //            raw: 2.99,
    //            display: '\u00A32.99',
    //            currency: "\u00A3"
    //        },
    //        us: {
    //            raw: 3.99,
    //            display: "\u00243.99",
    //            currency: "\u0024"
    //        },
    //        au: {
    //            raw: 5.99,
    //            display: "\u00245.99",
    //            currency: "\u0024"
    //        }
    //    }
    //},
    //{
    //    type: "Addon",
    //    name: "Scrawl Adult",
    //    pack: 1,
    //    addonId: "scrawl_adult",
    //    forGameId: "scrawl",
    //    enabled: true,
    //    logo: ScrawlLogo,
    //    description: "For those with less innocent minds, an optional 17+ game mode!",
    //    productId: process.env.REACT_APP_SCRAWL_ADULT_PID,
    //    supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
    //    price: 2.99,
    //    storeSlug: '/shop/addons/scrawl-adult',
    //    gameInfo: {
    //        minAge: 17,
    //        minPlayers: 3,
    //        avgRoundLength: 600,
    //        avgRoundLengthText: '20 Mins',
    //        descriptions: [
    //            {
    //                header: "WARPED MINDS WELCOME",
    //                body: "We've heard what some of you have been doing on Scrawl, and we thought sure. Why not? For those with less innocent minds, an optional 17+ game mode is now available!"
    //            }
    //        ],
    //        //banner: "Requires Scrawl",
    //    },
    //    upsellIds: ["colour_brain_junior", "catchphrase", "mdmd"],
    //    meta: {
    //        cardLogo: ScrawlCardLogo,
    //        cardBackground: ScrawlCardBackground,
    //        cardPriceColour: '#EC0080',
    //        storeBackground: ScrawlStoreBackground,
    //        storeBackgroundColour: '#FFD900',
    //        storeInfoBackground: '#FFFFFF',
    //        storeLogo: ScrawlStoreLogo,
    //        storeAccentColour: '#212B3D',
    //        gameMenuTextColour: '#ffffff',
    //        gameMenuBackgroundColour: '#EA085E',
    //        previewImages: {
    //            mobile1: ScrawlMobilePreview1,
    //            mobile2: ScrawlMobilePreview2,
    //            desktop1: ScrawlDesktopPreview1,
    //            desktop2: ScrawlDesktopPreview2,
    //        },
    //        tinyCard: ScrawlTinyCard,
    //    },
    //    pricing: {
    //        gb: {
    //            raw: 2.99,
    //            display: '\u00A32.99',
    //            currency: "\u00A3"
    //        },
    //        us: {
    //            raw: 3.99,
    //            display: "\u00243.99",
    //            currency: "\u0024"
    //        },
    //        au: {
    //            raw: 5.99,
    //            display: "\u00245.99",
    //            currency: "\u0024"
    //        }
    //    }
    //},
    //{
    //    type: "Addon",
    //    name: "Catchphrase Question Pack",
    //    pack: 1,
    //    addonId: "catchphrase_addon_1",
    //    forGameId: "catchphrase",
    //    enabled: true,
    //    logo: CatchphraseLogo,
    //    description: "50 new Catchphrases, free and ready to play!",
    //    supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
    //    //productId: process.env.REACT_APP_SCRAWL_ADULT_PID,
    //    price: 0,
    //    storeSlug: '/shop/addons/catchphrase-addon-1',
    //    gameInfo: {
    //        minAge: 8,
    //        minPlayers: 1,
    //        avgRoundLengthText: '20 mins',
    //        descriptions: [
    //            {
    //                header: "CATCHPHRASE JUST GOT FRESHER",
    //                body: "We've added 50 brand new, totally free catchphrases to shake up your next round. From clever clues to laugh-out-loud phrases-can your team guess them all in time?"
    //            }
    //        ],
    //        //banner: "Requires Scrawl",
    //    },
    //    upsellIds: ["catchphrase", "scrawl_adult", "pub_quiz"],
    //    meta: {
    //        cardLogo: CatchphraseCardLogo,
    //        cardBackground: CatchphraseCardBackground,
    //        cardPriceColour: '#10232B',
    //        storeBackground: CatchphraseStoreBackground,
    //        storeBackgroundColour: '#FFFFFF',
    //        storeInfoBackground: '#FFFFFF',
    //        storeLogo: CatchphraseStoreLogo,
    //        storeAccentColour: '#1e236e',
    //        gameMenuTextColour: '#FFFFFF',
    //        gameMenuBackgroundColour: '#2c34a0',
    //        previewImages: {
    //            mobile1: CatchphraseMobilePreview1,
    //            mobile2: CatchphraseMobilePreview2,
    //            desktop1: CatchphraseDesktopPreview1,
    //            desktop2: CatchphraseDesktopPreview2,
    //        },
    //        tinyCard: CatchphraseTinyCard,
    //    },
    //    pricing: {
    //        gb: {
    //            raw: 0,
    //            display: 'FREE',
    //            currency: "\u00A3"
    //        },
    //        us: {
    //            raw: 0,
    //            display: "FREE",
    //            currency: "\u0024"
    //        },
    //        au: {
    //            raw: 0,
    //            display: "FREE",
    //            currency: "\u0024"
    //        }
    //    }
    //},
    //{
    //    type: "Addon",
    //    name: "Colour Brain Junior",
    //    pack: 1,
    //    addonId: "colour_brain_junior",
    //    supportedPlatforms: [APP_TYPES.WEB, APP_TYPES.FIRE_TV, APP_TYPES.SKY, APP_TYPES.ROKU],
    //    forGameId: "colour_brain",
    //    enabled: true,
    //    logo: ColourBrainLogo,
    //    description: "Questions kids should know but adults might struggle with!",
    //    //productId: process.env.REACT_APP_SCRAWL_ADULT_PID,
    //    price: 0,
    //    storeSlug: '/shop/addons/colour-brain-junior',
    //    gameInfo: {
    //        minAge: 6,
    //        minPlayers: 2,
    //        avgRoundLengthText: '20 mins',
    //        descriptions: [
    //            {
    //                header: "KIDS KNOW BEST",
    //                body: "All the questions are based on things kids should know but adults might struggle with, such as, 'What colour are Strawberry Millions?'"
    //            }
    //        ],
    //        //banner: "Requires Scrawl",
    //    },
    //    upsellIds: ["scrawl_adult", "catchphrase", "pub_quiz"],
    //    meta: {
    //        cardLogo: ColourBrainCardLogo,
    //        cardBackground: ColourBrainCardBackground,
    //        cardPriceColour: '#10232B',
    //        storeBackground: ColourBrainStoreBackground,
    //        storeBackgroundColour: '#FFFFFF',
    //        storeInfoBackground: '#FFFFFF',
    //        storeLogo: ColourBrainStoreLogo,
    //        storeAccentColour: '#93A2AA',
    //        gameMenuTextColour: '#000000',
    //        gameMenuBackgroundColour: '#ffffff',
    //        previewImages: {
    //            mobile1: ColourBrainMobilePreview1,
    //            mobile2: ColourBrainMobilePreview2,
    //            desktop1: ColourBrainDesktopPreview1,
    //            desktop2: ColourBrainDesktopPreview2,
    //        },
    //        tinyCard: ColourBrainTinyCard,
    //    },
    //    pricing: {
    //        gb: {
    //            raw: 0,
    //            display: 'FREE',
    //            currency: "\u00A3"
    //        },
    //        us: {
    //            raw: 0,
    //            display: "FREE",
    //            currency: "\u0024"
    //        },
    //        au: {
    //            raw: 0,
    //            display: "FREE",
    //            currency: "\u0024"
    //        }
    //    }
    //},
    
];

export default GameAddonList;
